import { Component, OnInit } from '@angular/core';
import { SignoutService } from '../services/signout.service';
import { SkillsCheckService } from '../services/skills-check.service';

@Component({
  selector: 'app-agent-break-page',
  templateUrl: './agent-break-page.component.html',
  styleUrls: ['./agent-break-page.component.scss']
})
export class AgentBreakPageComponent implements OnInit {
  constructor(private signoutService: SignoutService, private skillsCheckService: SkillsCheckService) {}

  ngOnInit(): void {
    this.skillsCheckService.stopSkillsCheckMonitor();
  }

  signOut() {
    this.signoutService.signout();
  }
}
